import { gql } from '@apollo/client';

export const COMPLETE_TRANSLATION_FRAGMENT = gql`
  fragment CompleteTranslationFields on CompleteTranslation {
    en
    es
    fr
    zh
  }
`;
